





import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import { Bar, mixins } from 'vue-chartjs-typescript';

const { reactiveProp } = mixins;

@Component({
  extends: Bar,
  mixins: [reactiveProp],
})
export default class BarChartComponent extends Vue {

  @Prop()
  public chartData: any;

  @Prop({ default: () => ({legend: {display: false}}) })
  public options!: object;

  public renderChart!: (chartData: any, options: any) => void;

  public mounted() {
    this.renderChart(this.chartData, this.options);
  }

  @Watch('chartData')
  public fillData() {
    this.renderChart(this.chartData, this.options);
  }

}

